export const CONTRACTOR_ENTITY                          = 'contractor';
export const CONTRACTOR_PAYMENT_ENTITY                  = 'contractorPayment';
export const CONTRACTOR_DOCUMENT_ENTITY                 = 'contractorDocument';

export const EMPLOYEE_ENTITY                            = 'employee';
export const EMPLOYEE_PAYSTUB_ENTITY                    = 'employeePaystub';
export const EMPLOYEE_DOCUMENT_ENTITY                   = 'employeeDocument';
export const EMPLOYEE_BENEFIT_ENTITY                    = 'employeeBenefit';
export const EMPLOYEE_DEDUCTION_ENTITY                  = 'employeeDeduction';
export const EMPLOYEE_WAGE_ENTITY                       = 'employeeWage';

export const LEAVE_POLICY_ENTITY                        = 'leavePolicy';
export const LOCATION_ENTITY                            = 'location';
export const LOCATION_RULE_ENTITY                       = 'locationRule';

export const PAYROLL_ENTITY                             = 'payroll';
export const PAYROLL_PAYMENT_ENTITY                     = 'payrollPayment';

export const BILLING_INVOICE_ENTITY                     = 'invoice';

export const USER_ENTITY                                = 'user';

export const SCHEDULE_ENTITY                            = 'schedule';

export const TAXATION_DOCUMENT_ENTITY                   = 'document';
export const TAXATION_DEPOSIT_ENTITY                    = 'deposit';

export const WORKPLACE_ENTITY                           = 'workplace';
